module.exports = __webpack_public_path__ + "img/calafate.dd22dd2b.jpg";